import { render, staticRenderFns } from "./SharedPage.vue?vue&type=template&id=37d4a8f0&scoped=true&"
import script from "./SharedPage.vue?vue&type=script&lang=js&"
export * from "./SharedPage.vue?vue&type=script&lang=js&"
import style0 from "./SharedPage.vue?vue&type=style&index=0&id=37d4a8f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d4a8f0",
  null
  
)

export default component.exports